<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="徽章系列名" prop="seriesName" >
        <a-input v-model="form.seriesName" placeholder="请输入徽章系列名" />
      </a-form-model-item>
      <a-form-model-item label="徽章类型" prop="badgeType" >
        <a-select style="width: 100%" v-model="form.badgeType" placeholder="请选择徽章类型" allow-clear>
          <a-select-option v-for="(item, index) in this.customDict.BadgeTypeEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="剧本id 剧本票根时使用" prop="scriptId" v-if="form.badgeType === 2">
        <a-button type="dashed" @click="showBindScript" danger v-if="form.scriptName">
          <span>{{ form.scriptName }}</span>
        </a-button>
        <a-button type="dashed" @click="showBindScript" danger v-if="!form.scriptName">
          <span style="color: dodgerblue"> 绑定剧本</span>
        </a-button>
      </a-form-model-item>
      <a-form-model-item label="介绍 活动徽章必填" prop="introduction" >
        <a-input type="textarea" v-model="form.introduction" placeholder="请输入介绍 活动徽章必填" />
      </a-form-model-item>
      <a-form-model-item label="提醒 选填" prop="remind" >
        <a-input type="textarea" v-model="form.remind" placeholder="请输入提醒 选填" />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status" >
        <a-select style="width: 100%" v-model="form.status" placeholder="请选择状态" allow-clear>
          <a-select-option :value="1">启用</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="顺序 默认为1" prop="sort" >
        <a-input-number v-model="form.sort" :min="0" :max="127" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="绝版日期 成长/活动徽章选填" prop="outOfPrintTime" v-if="form.badgeType === 1 || form.badgeType === 3">
        <a-date-picker
          show-time
          style="width: 100%"
          v-model="form.outOfPrintTime"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          @change="onChange"
          allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <index-script-modal
      ref="IndexScriptModal"
      @select="indexScriptModalSelect"
      @selectName="indexScriptModalName"
    ></index-script-modal>
  </a-drawer>
</template>

<script>
import { getBadgeSeries, addBadgeSeries, updateBadgeSeries } from '@/api/badge/badgeSeries'
import { mapGetters } from 'vuex'
import IndexScriptModal from '@/components/Script/IndexScriptModal.vue'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    IndexScriptModal
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        seriesName: null,
        badgeType: undefined,
        scriptId: null,
        scriptName: null,
        introduction: null,
        remind: null,
        status: 1,
        sort: 1,
        outOfPrintTime: null,
        createTime: null,
        updateTime: null,
        creator: null,
        modifier: null,
        isDeleted: null,
        remark: null,
        version: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        seriesName: [
          { required: true, message: '徽章系列名不能为空', trigger: 'blur' }
        ],
        badgeType: [
          { required: true, message: '徽章类型 1.成长徽章 2.剧本徽章 3.活动徽章不能为空', trigger: 'change' }
        ],
        status: [
          { required: true, message: '状态 0.禁用 1.启用不能为空', trigger: 'blur' }
        ],
        isDeleted: [
          { required: true, message: '逻辑删除标记，1：删除，0：未删除，默认0不能为空', trigger: 'blur' }
        ],
        version: [
          { required: true, message: '乐观锁不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onChange(value, dateString) {
      console.log(value, dateString)
      this.form.outOfPrintTime = dateString
    },
    indexScriptModalSelect(ids) {
      this.form.scriptId = ids
      console.log('获取到的ids', ids)
    },
    indexScriptModalName(name) {
      this.form.scriptName = name
      console.log('获取到的剧本名', name)
    },
    showBindScript: function() {
      this.$refs.IndexScriptModal.open()
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        seriesName: null,
        badgeType: undefined,
        scriptId: null,
        scriptName: null,
        introduction: null,
        remind: null,
        status: 1,
        sort: 1,
        outOfPrintTime: null,
        createTime: null,
        updateTime: null,
        creator: null,
        modifier: null,
        isDeleted: null,
        remark: null,
        version: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBadgeSeries(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateBadgeSeries(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addBadgeSeries(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
